import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";

import { makeNextOptions, getNextOptions, formatMessageEdit } from "utils";
import {
  addNewMessage,
  getIsMaximized,
  selectIsJAI,
  selectPropertyId,
  selectShowAllUnit,
  setBedRoomType,
  setDesiredMoveIn,
  setPrice,
  setReplies,
} from "slices";
import { getAppSSID } from "slices/window-slice/index";
import { createEventSignal, sendHayleyMessage } from "utils/methods/index";

import ExtraOption from "../ExtraOptions";

import ModalView from "./ModalView";

const UnitView = ({ replies, showButtons = true }) => {
  const dispatch = useDispatch();
  const isJAI = useSelector(selectIsJAI);
  const propertyId = useSelector(selectPropertyId);
  const isShowAll = useSelector(selectShowAllUnit);
  const isMaximized = useSelector(getIsMaximized);
  const SSID = useSelector(getAppSSID);
  const [focusedUnitIdx, setFocusedUnitIdx] = useState(0);

  const startScheduleTour = (data) => {
    if (isShowAll === "true") {
      dispatch(setBedRoomType(data.unit_floorplan));
      dispatch(setPrice(data.unit_rent_min));
      dispatch(setDesiredMoveIn(""));
    }

    formatMessageEdit("ScheduleTour", "scheduleTour", "unitView");
    let eventKeys = JSON.parse(localStorage.getItem(`events_${SSID}`)) || [];
    eventKeys.push("Schedule a tour");
    localStorage.setItem(`events_${SSID}`, JSON.stringify(eventKeys));

    const requestOption = {
      tag: "SAT_CLICKED",
      metric: "Click",
      propertyId: propertyId,
      sessionId: SSID,
      appSubsection: "Schedule a tour",
    };
    createEventSignal(requestOption);
  };

  const go2ContactUs = () => {
    getNextOptions("Form4ContactUs")
      .then((res) => {
        const { nextReplies, nextBotMessages } = makeNextOptions("ScheduleTour", res.data, res.extraData || undefined);

        dispatch(setReplies(nextReplies));
        dispatch(addNewMessage(nextBotMessages));

        if (nextBotMessages?.length > 0) {
          sendHayleyMessage({
            text: t(nextBotMessages[0].message) || "",
            queryType: "answer",
            ownerType: "agent",
            kgNodeValue: "Contact Me",
          });
        }
      })
      .catch((err) => {
        /** @todo Add error handling part */
      });

    let eventKeys = JSON.parse(localStorage.getItem(`events_${SSID}`)) || [];
    eventKeys.push("Contact me");
    localStorage.setItem(`events_${SSID}`, JSON.stringify(eventKeys));

    const requestOption = {
      tag: "CONTACT_ME_CLICKED",
      metric: "Click",
      propertyId: propertyId,
      sessionId: SSID,
      appSubsection: "Contact me",
    };
    createEventSignal(requestOption);
  };

  useEffect(() => {
    return () => {
      setFocusedUnitIdx(0);
    };
  }, []);

  const dataArr = replies?.options || [];

  const extraButtons = isJAI
    ? [
        {
          text: t("editSubOrg"),
          handleClick: () => window.open(`${process.env.REACT_APP_CRM_BASE_URL}/sites/${propertyId}/units`, "_blank"),
        },
      ]
    : null;

  return (
    <div>
      {dataArr?.length &&
        (isMaximized ? (
          <div className="hayley-flex hayley-w-full hayley-max-w-[calc(100dvw-150px)] hayley-overflow-scroll">
            {dataArr?.map((v, i) => (
              <ModalView
                key={i}
                isFloorPlan
                data={v.data}
                setFocusedUnitIdx={setFocusedUnitIdx}
                dataArr={dataArr}
                startScheduleTour={startScheduleTour}
                go2ContactUs={go2ContactUs}
                isShowAll={true}
                unitCase={replies?.unitCase}
              />
            ))}
          </div>
        ) : (
          <ModalView
            isFloorPlan
            data={dataArr[focusedUnitIdx].data}
            setFocusedUnitIdx={setFocusedUnitIdx}
            dataArr={dataArr}
            startScheduleTour={startScheduleTour}
            go2ContactUs={go2ContactUs}
            unitCase={replies?.unitCase}
          />
        ))}

      {showButtons ? <ExtraOption from="find_home" buttons={null} extraButtons={extraButtons} /> : null}
    </div>
  );
};

export default UnitView;
